import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../config/api';
import { ELEVENLABS_CONFIG } from '../../config/elevenlabs-api';


const AgentForm = ({ agent, onClose, onSubmit }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('active');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (agent) {
      setName(agent.name);
      setEmail(agent.email);
      setStatus(agent.status);
    }
  }, [agent]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const agentData = { name, email, status };

      if (agent) {
        await axios.put(`${API_BASE_URL}/agents/${agent.id}`, agentData, {
          headers: {
            Authorization: token,
          },
        });

        await axios.patch(
          `${ELEVENLABS_CONFIG.BASE_URL}/agents/${agent.elevenlabs_agent_id}`,
          {
            name, email, status
          },
          {
            headers: {
              'xi-api-key': ELEVENLABS_CONFIG.API_KEY,
              'Content-Type': 'application/json',
            },
          }
        );
      } else {
        await axios.post(`${ELEVENLABS_CONFIG.BASE_URL}/agents`, agentData, {
          headers: {
            'xi-api-key': ELEVENLABS_CONFIG.API_KEY
          },
        });
      }

      onSubmit();
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="status">Status:</label>
          <select
            id="status"
            className="form-control"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ marginLeft: '10px' }}
          >
            {loading ? 'Saving...' : (agent ? 'Update Agent' : 'Add Agent')}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AgentForm;
